import { useIsMutating } from '@tanstack/react-query';
import React, { useState, useSyncExternalStore } from 'react';
import { Button, Modal, Popover, Tag } from 'antd';
import { UserOutlined, PlusOutlined } from '@ant-design/icons';
import { useAuth } from './AuthProvider';
import { SavedSession } from './session';
import { SavedSessions, environmentColors } from './SavedSessions';
import { LoginPage } from '../pages/LoginPage';
import { getPendingWrites, subscribePendingWrites } from '../api/client';

export const SessionMenu: React.FC = () => {
  const { activeSession } = useAuth();
  const [open, setOpen] = useState(false);
  const [dialog, setDialog] = useState<{ session?: SavedSession } | null>(null);
  const [loading, setLoading] = useState(false);
  const writes = useSyncExternalStore(subscribePendingWrites, getPendingWrites) + useIsMutating();
  return <>
    <Popover trigger="click" open={open} onOpenChange={setOpen} placement="bottomRight" title="Admin sessions"
      content={<div style={{ width: 350, maxWidth: '80vw' }}>
        <SavedSessions onSelected={() => setOpen(false)} onReauthenticate={session => { setOpen(false); setDialog({ session }); }} />
        <Button className="mt-3" block icon={<PlusOutlined />} disabled={writes > 0} onClick={() => { setOpen(false); setDialog({}); }}>Add session</Button>
      </div>}>
      <Button type="text" icon={<UserOutlined />} aria-label="Switch session" className="max-w-full"
        style={{ height: 'auto', minHeight: 40, padding: '8px 12px', gap: 8 }}>
        <span className="inline-block max-w-40 truncate align-middle">{activeSession?.email}</span>
        {activeSession && <Tag color={environmentColors[activeSession.environment]} style={{ marginInlineEnd: 0 }}>{activeSession.environment === 'other' ? 'CUSTOM' : activeSession.environment.toUpperCase()}</Tag>}
      </Button>
    </Popover>
    <Modal open={!!dialog} centered title={dialog?.session ? 'Sign in again' : 'Add session'} footer={null} destroyOnHidden
      closable={!loading} maskClosable={!loading} keyboard={!loading} onCancel={() => setDialog(null)}>
      {dialog && <LoginPage embedded initialSession={dialog.session} onLoading={setLoading} onSuccess={() => setDialog(null)} />}
    </Modal>
  </>;
};
